import React from 'react';
import Page from '../components/Page';
import HeroSection from '../components/HeroSection';
import variables from '../styles/variables.module.scss';
import CasesSection from '../components/CasesSection';
import { cases } from '../data';

const CasePage = () => (
  <Page
    offset
    style={{ backgroundColor: variables.tuna }}
  >
    <HeroSection
      title={cases.title}
      stroke={cases.stroke}
      strokeColor={variables.cleanWhite}
      headline="Our"
      firstSideHeading={cases.firstSideHeading}
      secondSideHeading={cases.secondSideHeading}
      offset
    />
    <CasesSection />
  </Page>
);

export default CasePage;
